export function checkSupportedFormatFunction(type: string, acceptedFormatList: string[]): boolean {
  return acceptedFormatList?.length ? acceptedFormatList?.includes(type) || true : true;
}
